import DataMapper from './DataMapper'
import CaseInvestigatorHistory from '../../models/CaseInvestigatorHistory'
import CaseInvestigatorHistoryRM from '../responsemodel/CaseInvestigatorHistoryRM'

class CaseInvestigatorHistoryDataMapper extends DataMapper<CaseInvestigatorHistoryRM, CaseInvestigatorHistory> {
  map = (rm: CaseInvestigatorHistoryRM) => new CaseInvestigatorHistory(rm.state, rm.name, rm.date, rm.startDate, rm.endDate, rm.remark, rm.document)
}
export default CaseInvestigatorHistoryDataMapper